import cx from 'classnames';
import type { ReactNode } from 'react';
import { appSet } from './appSet';
import { appSetFill } from './appSetFill';
import styles from './styles.module.css';

export interface IconProps {
  /** @private for Typography.Icon only. */
  className?: string;
  name: keyof typeof appSet | 'loading';
  inlineAlign?: 'sub' | 'baseline';
  /** @deprecated use Typography.Icon instead */
  color?: string;
  fill?: boolean;
}

/** @deprecated use Icon from kitt-universal instead */
export function Icon({ className, name, inlineAlign, color, fill }: IconProps): ReactNode {
  const wrapperProps = {
    ...(color && { style: { color } }),
  };

  if (name === 'loading') {
    return (
      <div className={styles.Loader} {...wrapperProps}>
        <appSet.loader />
      </div>
    );
  }

  // Default to hash icon if name was not found
  const Graphic = fill ? appSetFill[name] || appSetFill.hash : appSet[name] || appSet.hash;

  return (
    <div
      className={cx(
        styles.IconContainer,
        {
          [styles.InlineAlign]: Boolean(inlineAlign),
          [styles.InlineAlignSub]: inlineAlign === 'sub',
        },
        className,
      )}
      {...wrapperProps}
    >
      <Graphic />
    </div>
  );
}
